import { render, staticRenderFns } from "./TagAddView.vue?vue&type=template&id=1f8c0582"
import script from "./TagAddView.vue?vue&type=script&lang=js"
export * from "./TagAddView.vue?vue&type=script&lang=js"
import style0 from "./TagAddView.vue?vue&type=style&index=0&id=1f8c0582&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports